const nodejs = `const WebSocket = require('ws');
const zlib = require('zlib');

const path = "HHOOSSTT"; 
const CHANNEL = AAPPII; 

let socket;
let receivedMessage = "";

function init() {
  socket = new WebSocket(path);
  socket.on('open', onOpen);
  socket.on('message', onMessage);
  socket.on('error', onError);
  // socket.on('close', onClose);
}

function onOpen() {
  console.log("WebSocket connected");
  socket.send(JSON.stringify(CHANNEL));
}

function onError(error) {
  console.log("WebSocket error:", error);
}

function onMessage(message) {
  const buf = Buffer.from(message);
  const decodedMsg = zlib.gunzipSync(buf).toString('utf-8');
  console.log(decodedMsg);
  if (decodedMsg === "Ping") {
    socket.send('Pong');
    console.log('Pong');
  }
  receivedMessage = decodedMsg;
}

// function onClose() {
//   console.log("WebSocket closed");
// }

init();`
export default nodejs



// WEBPACK FOOTER //
// ./src/utils/codeWs/nodejs.js